// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"d012edef","940":"d012edef","968":"d012edef"}[chunkId] + ".chunk.css";
};